import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import LoginOne from './loginOne/index.vue';
import LoginTwo from './loginTwo/index.vue';
export default {
  __name: 'App',
  setup(__props) {
    let domainName = ref(window.location.host);
    const showLoginCq = domainName.value.indexOf('cquckcsz.zhihuishu.com') > -1 ? true : false;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [!_unref(showLoginCq) ? (_openBlock(), _createBlock(LoginOne, {
        key: 0
      })) : _createCommentVNode("", true), _unref(showLoginCq) ? (_openBlock(), _createBlock(LoginTwo, {
        key: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
};